import React from 'react'
import moment from 'moment'
import RecordSection from './_RecordSection'
import { Text, View } from '@react-pdf/renderer'
import InfoLine from './_InfoLine'

const CALNotes = ({ notes }) => {
  const filteredNotes = notes?.filter((n) => n.showInRecord) ?? []

  if (filteredNotes.length === 0) {
    return null
  }

  return (
    <RecordSection title="Clinical Advice, Governance & Safeguarding Notes">
      <View
        style={{
          width: '100%',
          gap: 5,
          fontSize: 10,
          paddingHorizontal: 5,
          paddingVertical: 2,
        }}
      >
        {filteredNotes.map((note, index) => (
          <View
            rowGap={1}
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',

              padding: 5,
            }}
          >
            <View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                width: '100%',
                fontSize: 10,
                borderTopStyle: index === 0 ? null : 'solid',
                borderColor: '#616161',
              }}
            >
              <View>
                <Text style={{ fontFamily: 'Helvetica-Bold' }}>
                  {note.person.firstName} {note.person.lastName}
                </Text>
              </View>
              <View>
                <Text style={{ fontFamily: 'Helvetica-Bold' }}>
                  {moment(note.createdAt).format('DD/MM/yyyy HH:mm')}
                </Text>
              </View>
            </View>
            <Text>{note.note}</Text>
          </View>
        ))}
      </View>
    </RecordSection>
  )
}

export default CALNotes
